import { CheckoutJourney, CheckoutStep, JourneyPageConfig } from '../models/checkout-journey.types';
import { CustomerJourneyType } from '../models/checkout.model';
import { BOOKING_JOURNEY } from './journey-booking';
import { FREE_BOOKING_JOURNEY } from './journey-free-booking';
import { RESERVATION_JOURNEY } from './journey-reservation';

export const CHECKOUT_JOURNEYS: Record<CustomerJourneyType, CheckoutJourney> = {
  [CustomerJourneyType.BOOKING]: BOOKING_JOURNEY,
  [CustomerJourneyType.FREE_BOOKING]: FREE_BOOKING_JOURNEY,
  [CustomerJourneyType.RESERVATION]: RESERVATION_JOURNEY,
};

export function getJourneyConfig(journeyType: CustomerJourneyType): CheckoutJourney {
  const config = CHECKOUT_JOURNEYS[journeyType];
  if (!config) {
    console.warn(`[Checkout] No journey config for: ${journeyType}`);
  }
  return config!;
}

export function getPageConfig(journeyType: CustomerJourneyType, route: string): JourneyPageConfig | undefined {
  return getJourneyConfig(journeyType)?.page.find((p) => p.pageRoute === route);
}

export function getStepIndicatorConfig(journeyType: CustomerJourneyType): CheckoutStep[] {
  const journey = getJourneyConfig(journeyType);
  if (!journey) return [];
  const labels = journey.stepLabels ?? journey.page.map((p) => p.label);
  if (journey.stepLabels && journey.stepLabels.length !== journey.page.length) {
    console.warn(
      `[Checkout] stepLabels length (${journey.stepLabels.length}) !== page length (${journey.page.length}) for journey "${journeyType}". Some step routes will be empty.`,
    );
  }
  return labels.map((label, i) => ({
    stepNumber: i + 1,
    ariaLabel: label,
    route: journey.page[i]?.pageRoute ? `/checkout/${journey.page[i].pageRoute}` : '',
  }));
}
